const config = {
    build_number: '601632',
    build_timestamp: '2025-05-15T17:29:25.442Z',
    build_commit: 'cbecf49fbffaa6929cc2270b06d3d5b7bd02c2cc',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
